import Reflux from 'reflux';
import { Map, fromJS } from 'immutable';
import EventObjectSearchActions from 'flux/actions/EventObjectSearchActions';
import EventViewStore from 'flux/stores/EventViewStore';
import BaseMixin from 'flux/stores/BaseMixin';
import EventChangeListenerMixin from 'flux/stores/EventChangeListenerMixin';

export default Reflux.createStore({
  listenables: [EventObjectSearchActions],

  mixins: [BaseMixin, EventChangeListenerMixin],

  init() {
    this.listenTo(EventViewStore, 'onEventChange');

    this.setStateAndTrigger(Map({ enabled: false }));
  },

  onToggleVisibility() {
    let willBeEnabled = this.getInState('enabled') ? false : true;
    this.setInState('enabled', willBeEnabled);

    this.deleteInStateAndTrigger('results');
  },

  onSetTerm(term) {
    let next = this.setInState('term', term);

    if (term.length < 3) {
      next = next.delete('results');
    } else {
      EventObjectSearchActions.search(this._teamId, this._eventId, term);
    }

    this.setStateAndTrigger(next);
  },

  onSearchCompleted(results) {
    this.setInStateAndTrigger('results', fromJS(results));
  },

  _getSelectedItem() {
    return this.getInState('results').findIndex((res) => res.get('selected'));
  },

  _changeSelectedItem(prev, next) {
    prev = prev >= 0 ? prev : 0;

    this.setStateAndTrigger(
      this.getState()
        .setIn(['results', prev, 'selected'], false)
        .setIn(['results', next, 'selected'], true),
    );
  },

  onMoveSelectionUp() {
    let selected = this._getSelectedItem();

    let nextSelected = 0;

    if (selected > 0) {
      nextSelected = selected - 1;
    }

    this._changeSelectedItem(selected, nextSelected);
  },

  onMoveSelectionDown() {
    let selected = this._getSelectedItem();

    let nextSelected = selected + 1;

    let next = this.getState();

    if (next.hasIn(['results', nextSelected])) {
      this._changeSelectedItem(selected, nextSelected);
    }
  },
});
